<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/partnerProductAccountDetail', query: { id: this.$route.query.ppa_rid } }"
                    >合作产品路径详情</el-breadcrumb-item
                >
                <el-breadcrumb-item>合作产品路径初始化{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                    <el-button size="small" plain @click="reset">重置</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                    ></el-input>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, checkNumber, processColDataToEdit } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'commodityFlowStateInitEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.getInsertDefaultData();
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                status: {
                    request_uri: 'dropdownCommonStatus',
                    title: '状态',
                    ref: 'status_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                commodity_flow_applicable: {
                    request_uri: 'dropdownCommodityFlowApplicable',
                    title: '计算类型',
                    ref: 'commodity_flow_applicable_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                month: {
                    tips: '示例：2024-01'
                },
                end_month: {
                    tips: '示例：2024-12'
                }
            };
        },
        initFormRule() {
            this.rules = {
                month: [{ required: true, message: '请输入年月，示例：2024-01', trigger: 'blur' }],
                end_month: [{ required: false, message: '请输入结束年月，示例：2024-12', trigger: 'blur' }],
                quantity_opening_balance: [{ required: false, message: '请输入期初余额', trigger: 'blur' }],
                quantity_consumption: [{ required: true, message: '请输入期初消化', trigger: 'blur' }],
                status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
                commodity_flow_applicable: [{ required: true, message: '计算类型', trigger: 'blur' }],
                unit_price_taxincluded: [{ required: true, message: '请输入UPT初始化', trigger: 'blur' }],
                unit_price_taxexcluded: [{ required: true, message: '请输入UP初始化', trigger: 'blur' }],
                unit_price_taxincluded_auxiliary: [{ required: true, message: '请输入UPTX初始化', trigger: 'blur' }],
                unit_expense_quota_receivable: [{ required: true, message: '请输入EQR初始化', trigger: 'blur' }],
                unit_sales_standard_revenue: [{ required: true, message: '请输入USSR初始化', trigger: 'blur' }],
                unit_expense_quota_adjusted: [{ required: true, message: '请输入UEQA初始化', trigger: 'blur' }],
                unit_expense_quota_flow: [{ required: true, message: '请输入UEQF初始化', trigger: 'blur' }],
                unit_sales_standard_margin: [{ required: true, message: '请输入USSM初始化', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id || '';
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                ppa_rid: this.data.ppa_rid || this.$route.query.ppa_rid || '',
                month: this.data.month || '',
                end_month: this.data.end_month || '',
                quantity_opening_balance: this.data.quantity_opening_balance,
                quantity_consumption: this.data.quantity_consumption || '0',
                unit_price_taxincluded: this.data.unit_price_taxincluded || '0',
                unit_price_taxexcluded: this.data.unit_price_taxexcluded || '0',
                unit_price_taxincluded_auxiliary: this.data.unit_price_taxincluded_auxiliary || '0',
                unit_expense_quota_receivable: this.data.unit_expense_quota_receivable || '0',
                unit_sales_standard_revenue: this.data.unit_sales_standard_revenue || '0',
                unit_expense_quota_adjusted: this.data.unit_expense_quota_adjusted || '0',
                unit_expense_quota_flow: this.data.unit_expense_quota_flow || '0',
                unit_sales_standard_margin: this.data.unit_sales_standard_margin || '0',
                commodity_flow_applicable: this.data.commodity_flow_applicable || '1',
                status: this.data.status || '1'
            };
        },
        reset() {
            this.formData.quantity_opening_balance = '0';
            this.formData.quantity_consumption = '0';
            this.formData.unit_price_taxincluded = '0';
            this.formData.unit_price_taxexcluded = '0';
            this.formData.unit_price_taxincluded_auxiliary = '0';
            this.formData.unit_expense_quota_receivable = '0';
            this.formData.unit_sales_standard_revenue = '0';
            this.formData.unit_expense_quota_adjusted = '0';
            this.formData.unit_expense_quota_flow = '0';
            this.formData.unit_sales_standard_margin = '0';
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).commodity_flow_state_init;

            processColDataToEdit(
                temp,
                this,
                {
                    white: [
                        'month',
                        'end_month',
                        'quantity_opening_balance',
                        'quantity_consumption',
                        'unit_price_taxincluded',
                        'unit_price_taxexcluded',
                        'unit_price_taxincluded_auxiliary',
                        'unit_expense_quota_receivable',
                        'unit_sales_standard_revenue',
                        'unit_expense_quota_adjusted',
                        'unit_expense_quota_flow',
                        'unit_sales_standard_margin'
                    ]
                },
                {
                    commodity_flow_applicable_label: 'commodity_flow_applicable',
                    status_label: 'status'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/partnerProductAccountDetail?id=' + this.$route.query.ppa_rid });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .commodityFlowStateInitDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //获取新增默认数据
        getInsertDefaultData() {
            this.$api
                .commodityFlowStateInitInsertDefaultData({ ppa_rid: this.$route.query.ppa_rid })
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'commodityFlowStateInitUpdate';
            } else {
                uri = 'commodityFlowStateInitInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>